import SearchByReferenceFormConfig from "./form";
import { ProviderInvoiceDataType } from "@/api/ProviderInvoiceApi";
import { ReactNode, useEffect, useRef, useState } from "react";
import DynamicForm, { DynamicFormRef } from "@mavichpe/dynamic-forms";
import LoadingScreen from "@components/content/LoadingScreen";
import { loadReferenceFormLabel } from "@utils/Forms";
import { useAppSelector } from "@/store/hooks";
import { Button, Col, Row, Table } from "reactstrap";
import { performReferenceSearch, REFERENCE_DOCUMENT_LABELS, SearchByReferenceResultRowData } from "@utils/ReferenceSearchUtils";
import moment from "moment";
import { formatMoneyValue } from "@utils/Currency";
import DropdownActionsMenu from "@components/content/DropdownMenu";

export type SearchByReferenceFormDataType = {
  reference_number: string | undefined
};

const SearchByReferenceForm = () => {
  const formRef = useRef<DynamicFormRef>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [searchPerformed, setSearchPerformed] = useState<boolean>(false);
  const suscriptionData = useAppSelector((state) => state.suscription.suscription);
  const [formConfig, setFormConfig] = useState<any>();
  const [documents, setDocuments] = useState<SearchByReferenceResultRowData[]>([]);

  useEffect(() => {
    loadFormConfig()
  }, [suscriptionData])

  const loadFormConfig = () => {
    const formConfig = loadReferenceFormLabel(SearchByReferenceFormConfig, suscriptionData);
    if (suscriptionData?.id) {
      setFormConfig(formConfig)
    }
  }

  const generateReport = async (data: SearchByReferenceFormDataType) => {
    setIsLoading(true)
    try {
      const documents = await performReferenceSearch(`${data.reference_number || ""}`)
      setDocuments(documents)
      setSearchPerformed(true);
    } catch (err) {

    } finally {
      setIsLoading(false)
    }
  }

  const generateDocumentTableEntries = (): ReactNode[] => {
    return documents.map(d => {

      const documentName = REFERENCE_DOCUMENT_LABELS[d.kind]
      const date = moment(d.fecha, "YYYY-MM-DD")
      const formatDate = date.format("DD-MM-YYYY")
      return (
        <tr>
          <td>
            {formatDate}
          </td>
          <td>
            {documentName}
          </td>
          <td>
            {d.numero}
          </td>
          <td>
            {d.nombreFacturacion}
          </td>
          <td>
            {formatMoneyValue(d.total, Number(d.currency.currency_id || 0))}
          </td>
          <td>
            <DropdownActionsMenu
              actions={[
                {
                  isVisible: d.kind == "invoice",
                  actionTitle: "Ver Factura",
                  href: `/user/invoices/view/${d.id}`,
                  target: "_blank"
                },
                {
                  isVisible: d.kind == "quote",
                  actionTitle: "Ver Cotizacion",
                  href: `/user/quotes/view/${d.id}`,
                  target: "_blank"
                },
                {
                  isVisible: d.kind == "creditnote",
                  actionTitle: "Ver Nota de Credito",
                  href: `/user/creditnotes/view/${d.id}`,
                  target: "_blank"
                },
                {
                  isVisible: d.kind == "debitnote",
                  actionTitle: "Ver Nota de Debito",
                  href: `/user/debitnotes/view/${d.id}`,
                  target: "_blank"
                },
                {
                  isVisible: d.kind == "expense",
                  actionTitle: "Ver Gasto",
                  href: `/user/expenses/edit/${d.id}`,
                  target: "_blank"
                },
                {
                  isVisible: d.kind == "providerInvoice",
                  actionTitle: "Ver Factura de Provedor",
                  href: `provider-invoices/invoice/${d.id}`,
                  target: "_blank"
                },
                {
                  isVisible: d.kind == "buyInvoice",
                  actionTitle: "Ver Factura electronica de Compra",
                  href: `/user/buyInvoices/view/${d.id}`,
                  target: "_blank"
                },
                {
                  isVisible: d.kind == "settlement",
                  actionTitle: "Ver Liquidacion",
                  href: `/user/settlements/view/${d.id}`,
                  target: "_blank"
                },
              ]}
            />
          </td>
        </tr>)
    })
  }

  const renderResultDocuments = (): ReactNode => {
    return (
      <>
        <hr />
        <Table>
          <thead>
            <tr>
              <th>
                Fecha
              </th>
              <th>
                Tipo Documento
              </th>
              <th>
                # Documento
              </th>
              <th>
                Nombre
              </th>
              <th>
                Total
              </th>
              <th>
                Acciones
              </th>
            </tr>
          </thead>
          <tbody>
            {generateDocumentTableEntries()}
          </tbody>
        </Table>
      </>
    )

  }

  return (
    <>
      <p>
        Por favor ingrese el {suscriptionData?.reference_label || "numero de referencia"} para realizar la busqueda de documentos
      </p>
      {formConfig?.sections && (<>
        <DynamicForm<SearchByReferenceFormDataType>
          ref={formRef}
          id="report"
          formConfig={formConfig}
          onSubmit={generateReport}
        >
          <Row>
            <Col md={{
              offset: 2
            }}>
              <Button className="me-3" type="submit" color="primary" size="lg">Generar Reporte</Button>
            </Col>
          </Row>
        </DynamicForm>
      </>)}
      {searchPerformed && renderResultDocuments()}
      <LoadingScreen isLoading={isLoading} />
    </>
  )
}

export default SearchByReferenceForm;